module.exports = __webpack_public_path__ + "static/cover-e8373631bbe78c90f197646fd0498aef.png";